<template>
  <v-card outlined elevation="2" @click="showMore = !showMore">
    <v-card-title class="subtitle-2">
      <div class="no-wrap">
        {{ hazard.categoryDuties }}
      </div>
    </v-card-title>
    <v-card-subtitle>
      Premium: {{ premium }}
    </v-card-subtitle>
    <v-card-text v-if="showMore" class="pt-0">
      <v-row wrap>
        <v-col class="py-0" cols="6">
          <DisplayField label="Full Time" :value="hazard.fullTimeEmployees" />
        </v-col>
        <v-col class="py-0" cols="6">
          <DisplayField label="Part Time" :value="hazard.partTimeEmployees" />
        </v-col>
        <v-col class="py-0" cols="6">
          <DisplayField label="NAICS" :value="hazard.naics" />
        </v-col>
        <v-col class="py-0" cols="6">
          <DisplayField label="Rate" :value="hazard.rate" />
        </v-col>
        <v-col class="py-0" cols="6">
          <DisplayField label="Code" :value="hazard.classCode" />
        </v-col>
        <v-col class="py-0" cols="6">
          <DisplayField label="Est. Payroll" :value="hazard.estimatedPayroll" type="number" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped>
</style>

<script>
import DisplayField from '@/components/Shared/DisplayField.vue';
import displayFormatterService from '@/services/shared/displayFormatterService.js';

export default {
  name: 'HazardCard',
  components: { DisplayField },
  props: {
    hazard: {
      type: Object,
      default: null
    },
    location: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      showMore: false
    };
  },
  computed: {
    premium: function () {
      if ((this.hazard || null) === null) return displayFormatterService.formatCurrency(0);
      return displayFormatterService.formatCurrency(this.hazard.premium);
    }
  }
};
</script>
